import type { PublishContent, PublishFonts } from '@storeOld/reducers/publish'
import cx from 'classnames'
import type React from 'react'

import { getThemeClassName, getThemesByColor } from '../../utils'
import { PreviewContent } from './components/PreviewContent'
import { MenuIcon } from './icons'
import css from './Preview.module.scss'

// декоративные «кнопки окна» в шапке превью
const HEADER_DOTS_COUNT = 3

type Props = {
  bgColor: string
  contentType: PublishContent
  pagePreview: boolean
  fontType: PublishFonts
}

export const Preview: React.FC<Props> = ({
  bgColor,
  contentType,
  pagePreview,
  fontType,
}) => {
  const themeByColor = getThemesByColor(bgColor)
  const themeClassName = getThemeClassName(themeByColor)

  const bgColorStyle = { backgroundColor: bgColor }

  return (
    <div className={cx(css.container, themeClassName)}>
      <div className={css.previewHeader} style={{ backgroundColor: bgColor }}>
        {Array.from({ length: HEADER_DOTS_COUNT }, (_, index) => (
          <span key={index} className={css.dot} />
        ))}
      </div>

      <div
        className={cx(css.previewBody, {
          [css.withoutPagePreview]: !pagePreview,
        })}
        style={bgColorStyle}
      >
        <div className={css.previewSidebar}>
          <div className={css.sidebarHeader}>
            <span className={css.logoDot} />
            <div className={css.sidebarTitle}>Website</div>
          </div>
          <MenuIcon />
        </div>
        <PreviewContent
          contentType={contentType}
          fontType={fontType}
          pagePreview={pagePreview}
          bgColor={bgColor}
          themeByColor={themeByColor}
        />
      </div>
    </div>
  )
}
